/**
 * Rozhoduje, ktery z povolenych newsletter popupu (subscription-popup,
 * scratch-card-popup, ...) se na strance skutecne zobrazi.
 *
 * Kazdy kandidat ma atribut [data-popup-rotation]. Vyber je rovnomerne
 * nahodny mezi vsemi kandidaty aktualne v DOM (tedy jen mezi povolenymi -
 * vypnute popupy se v Liquidu vubec nevykresli). Vyber probehne jen jednou
 * za page load a je pak dostupny pres window.FoxTheme.PopupRotation.isChosen().
 *
 * Skript je vlozen jednou z kazde popup-family sekce - guard na zacatku
 * zajisti, ze se vice <script> tagu neprebije a rotace se nespusti vickrat.
 */
(function () {
  if (window.FoxTheme && window.FoxTheme.PopupRotation) return;
  window.FoxTheme = window.FoxTheme || {};

  var candidates = Array.prototype.slice.call(document.querySelectorAll('[data-popup-rotation]'));
  var chosenId = null;

  if (candidates.length) {
    var chosen = candidates[Math.floor(Math.random() * candidates.length)];
    chosenId = chosen.id;

    // Skryjeme "teaser" tlacitka (a jina [aria-controls] ovladaci prvky mimo
    // samotny popup) vsech nevybranych kandidatu, aby se nezobrazovala
    // vicero teaseru najednou a klik na ne neco viditelne neudelal.
    candidates.forEach(function (el) {
      if (el.id === chosenId) return;
      document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (control) {
        if (!el.contains(control)) control.hidden = true;
      });
    });
  }

  window.FoxTheme.PopupRotation = {
    isChosen: function (el) {
      if (window.Shopify && window.Shopify.designMode) return true;
      return !!chosenId && chosenId === el.id;
    },
  };
})();
